export default __webpack_public_path__ + "static/media/sign-up.b648b57f.svg";